/**
 * Mensajes de error estandarizados para la aplicación
 */

export const HTTP_ERROR_MESSAGES = {
  400: 'Solicitud inválida. Por favor, verifica los datos ingresados.',
  // No promete un redirect: por decision de producto la sesion vencida se avisa con un modal
  // y es el usuario el que decide cuando volver al login, para no perder lo que estaba
  // haciendo (#168). Prometer algo que el sistema no hace es el defecto que comparten
  // #130, #136 y #168.
  401: 'Tu sesión expiró. Volvé a ingresar para continuar.',
  403: 'No tienes permisos para realizar esta acción.',
  404: 'Recurso no encontrado.',
  408: 'La solicitud tardó demasiado. Por favor, intenta nuevamente.',
  409: 'Conflicto: el recurso ya existe o está en uso.',
  422: 'Error de validación. Por favor, verifica los datos.',
  429: 'Demasiadas solicitudes. Por favor, espera un momento.',
  500: 'Error del servidor. Por favor, intenta más tarde.',
  502: 'Error de conexión con el servidor. Por favor, intenta más tarde.',
  503: 'Servicio no disponible temporalmente. Por favor, intenta más tarde.',
  504: 'El servidor tardó demasiado en responder. Por favor, intenta nuevamente.',
};

export const NETWORK_ERROR_MESSAGES = {
  NETWORK_ERROR: 'Error de conexión. Verifica tu conexión a internet.',
  TIMEOUT: 'La solicitud tardó demasiado. Verifica tu conexión.',
  UNKNOWN: 'Ocurrió un error inesperado. Por favor, intenta nuevamente.',
};

/**
 * Obtiene un mensaje de error amigable basado en el código HTTP
 */
export const getHttpErrorMessage = (statusCode) => {
  return HTTP_ERROR_MESSAGES[statusCode] || HTTP_ERROR_MESSAGES[500];
};

/**
 * Obtiene un mensaje de error para errores de red
 */
export const getNetworkErrorMessage = (error) => {
  if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
    return NETWORK_ERROR_MESSAGES.TIMEOUT;
  }
  if (error.message === 'Network Error' || !error.response) {
    return NETWORK_ERROR_MESSAGES.NETWORK_ERROR;
  }
  return NETWORK_ERROR_MESSAGES.UNKNOWN;
};

